import { render, staticRenderFns } from "./TeamsInfoTable.vue?vue&type=template&id=6f7c5d5b&"
import script from "./TeamsInfoTable.vue?vue&type=script&lang=js&"
export * from "./TeamsInfoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports